import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to the element matching location.hash on route change and hash change.
 * Also smoothly scrolls when the hash link is clicked while already on the page.
 * Retries a few times in case the target element renders after the initial mount
 * (e.g. CMS pages load their blocks asynchronously).
 */
export default function ScrollToHash() {
  const { pathname, hash, key } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo({ top: 0, behavior: "instant" });
      return;
    }
    const id = decodeURIComponent(hash.slice(1));
    let cancelled = false;
    const timeouts = [];
    const tryScroll = (attemptsLeft) => {
      if (cancelled) return;
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
        return;
      }
      if (attemptsLeft > 0) {
        timeouts.push(window.setTimeout(() => tryScroll(attemptsLeft - 1), 150));
      }
    };
    // First attempt after a short delay, then up to 20 retries (≈3s total)
    timeouts.push(window.setTimeout(() => tryScroll(20), 60));
    return () => {
      cancelled = true;
      timeouts.forEach((t) => window.clearTimeout(t));
    };
  }, [pathname, hash, key]);

  return null;
}
